export default "__VITE_ASSET__DJn1OFaX__"